/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Return_Fee_Exceeds_PaidInputs */

const vi_error_return_fee_exceeds_paid = /** @type {(inputs: Error_Return_Fee_Exceeds_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phí trả hàng chỉ được lấy từ tiền khách đã trả dư. Đơn chưa thu đủ thì không có phí.`)
};

/**

* @param {Error_Return_Fee_Exceeds_PaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_return_fee_exceeds_paid = /** @type {((inputs?: Error_Return_Fee_Exceeds_PaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Return_Fee_Exceeds_PaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_return_fee_exceeds_paid(inputs)
});